'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BibTextSlide = require('./components/BibTextSlide.component');

Object.defineProperty(exports, 'BibTextSlide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BibTextSlide).default;
  }
});

var _SliderJacketCover = require('./components/SliderJacketCover.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SliderJacketCover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/slider-jacket-cover/lib/index.js
// module id = 588
// module chunks = 3 4 9